import { useEffect } from "react";
import CustomDialog from "../../../components/common/dialogs/CustomDialog";
import { Bl } from "../../../interfaces/bl-export/blexport.interface";
import { useCreateBlMutation } from "../../../services/bl-export/BLExportService";
import CloneBLPreload, { SkeletonBlForm } from "../forms/CloneBLPreload";
import CustomModalAlert from "../../../components/CustomModalAlert";

interface props {
  blToClone?: Bl;
  isOpen: boolean;
  onClose: () => void;
  callback: () => void;
}

const ModalCloneBl = ({ blToClone, isOpen, onClose, callback }: props) => {
  const [createBlMutation, { isSuccess, isError, reset }] = useCreateBlMutation();

  const handleCloseSuccess = () => {
    onClose();
    setTimeout(reset, 200);
  };

  useEffect(() => {
    if (isSuccess === true) {
      callback();
      return;
    }
  }, [isSuccess, callback]);

  if (isError === true) {
    return (
      <CustomModalAlert
        onClose={handleCloseSuccess}
        show={isError}
        type="error"
        message="No se pudo clonar el BL. Intente luego"
      />
    );
  }

  if (isSuccess === true) {
    return (
      <CustomModalAlert
        onClose={handleCloseSuccess}
        show={isSuccess}
        type="success"
        message="El BL se ha clonado correctamente"
      />
    );
  }

  return (
    <CustomDialog
      maxWidth="md"
      title="Clonar BL"
      isOpen={isOpen}
      handleClose={onClose}
      hideActionButtons
    >
      {blToClone !== undefined ? (
        <CloneBLPreload
          blToClone={blToClone}
          submitAction={(values) => {
            createBlMutation(values);
          }}
        />
      ) : (
        <SkeletonBlForm />
      )}
    </CustomDialog>
  );
};

export default ModalCloneBl;
